import $ from "jquery";
import "../styles/zoom.scss";
import { gsap } from "gsap";

$(() => {
  $("[data-lightbox]").each(function () {
    const zoomInButton = $(".lightbox-button", this);
    const lightbox = $(".lightbox", this);
    const closeBtn = $(".close-btn", this);
    const chart = $(".lightbox svg", this);

    zoomInButton.on("click", function () {
      lightbox.css("display", "flex");
      $("body").addClass("graph-open");
    });

    closeBtn.on("click", function () {
      lightbox.hide();
      // body add graph-open class
      $("body").removeClass("graph-open");
    });

    // Zoom and pan functionality
    let scale = 1;
    let originX = 0;
    let originY = 0;
    let isPanning = false;
    let startX, startY;

    const tween = gsap.to(chart, {
      x: 0,
      y: 0,
      scale: 1,
      duration: 0.5,
      repeat: 0,
      ease: "expo",
    });

    function checkElmentOutsideAndIfSoMoveToLimits() {
      const boundingRect = chart[0].getBoundingClientRect();
      const chartWidth = boundingRect.width;
      const chartHeight = boundingRect.height;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      console.log({ chartWidth, chartHeight, windowWidth, windowHeight });

      const currentY = tween.vars.y;
      const currentX = tween.vars.x;
      console.log({ currentX, currentY });

      const right = (windowWidth - chartWidth) / 2 - currentX;
      const left = (windowWidth - chartWidth) / 2 + currentX;
      const top = (windowHeight - chartHeight) / 2 + currentY;
      const bottom = (windowHeight - chartHeight) / 2 - currentY;

      console.log({ right, left, top, bottom });

      // if is inside the window in some way
      const shownY = Math.min(top, bottom);
      const shownX = Math.min(left, right);
      if (-shownY > chartHeight && -shownX > chartWidth) {
        return;
      }

      if (
        // we check if is to the left of the window outside
        // or to the right of the window outside
        left < -chartWidth ||
        right < -chartWidth
      ) {
        tween.vars.x = 0;
        tween.vars.scale = 1;
        originX = 0;
      }

      if (
        // we check if is to the top of the window outside
        // or to the bottom of the window outside
        top < -chartHeight ||
        bottom < -chartHeight
      ) {
        tween.vars.y = 0;
        tween.vars.scale = 1;
        originY = 0;
      }

      // if (Math.abs(top) > chartHeight) {
      //   tween.vars.y = (windowHeight - chartHeight) / 2;
      //   originY = (windowHeight - chartHeight) / 2;
      // }
      // if is not in the window
      // if (Math.min(bottom, top) < chartHeight) {
      //   if (top > bottom) {
      //     tween.vars.y = (windowHeight - chartHeight) / 2;
      //   } else {
      //     tween.vars.y = -(windowHeight - chartHeight) / 2;
      //   }
      // }

      // tween.vars.x = originX;
      // tween.vars.y = originY;
      tween.invalidate().restart();
    }

    chart.on("wheel", function ({ originalEvent: event }) {
      event.preventDefault();
      const scaleAmount = 0.1;
      if (event.deltaY < 0) {
        scale += scaleAmount;
      } else {
        scale -= scaleAmount;
        scale = Math.max(0.1, scale); // Prevent scaling below 100%
      }

      tween.vars.scale = scale;
      tween.invalidate().restart();

      checkElmentOutsideAndIfSoMoveToLimits();
    });

    chart.on("mousedown", function ({ originalEvent: event }) {
      isPanning = true;
      startX = event.pageX - originX;
      startY = event.pageY - originY;
      chart.css("cursor", "grabbing");
    });

    $(document)
      .on("mousemove", function ({ originalEvent: event }) {
        if (isPanning) {
          originX = event.pageX - startX;
          originY = event.pageY - startY;
          // chart.css(
          //   "transform",
          //   `translate(${originX}px, ${originY}px) scale(${scale})`
          // );
          tween.vars.x = originX;
          tween.vars.y = originY;
          tween.invalidate().restart();
        }
      })
      .on("mouseup", function () {
        // if (!isPanning) return;

        isPanning = false;
        chart.css("cursor", "move");
        checkElmentOutsideAndIfSoMoveToLimits();
      });

    chart.on("touchend", function () {
      checkElmentOutsideAndIfSoMoveToLimits();
    });

    chart.on("touchstart", function ({ originalEvent: event }) {
      if (event.touches.length === 1) {
        event.preventDefault();
        startX = event.touches[0].pageX;
        startY = event.touches[0].pageY;
      }
    });

    chart.on("touchmove", function ({ originalEvent: event }) {
      if (event.touches.length === 1) {
        event.preventDefault();
        const { pageX: touchX, pageY: touchY } = event.touches[0];
        originX += touchX - startX;
        originY += touchY - startY;
        startX = touchX;
        startY = touchY;
        tween.vars.x = originX;
        tween.vars.y = originY;
        tween.vars.scale = scale;
        tween.invalidate().restart();

        // chart.css(
        //   "transform",
        //   `translate(${originX}px, ${originY}px) scale(${scale})`
        // );
      }
    });

    chart.on("touchstart", function ({ originalEvent: event }) {
      if (event.touches.length === 2) {
        event.preventDefault();
        const distX = event.touches[0].pageX - event.touches[1].pageX;
        const distY = event.touches[0].pageY - event.touches[1].pageY;
        startX = Math.sqrt(distX * distX + distY * distY);
      }
    });

    chart.on("touchmove", function ({ originalEvent: event }) {
      if (event.touches.length === 2) {
        event.preventDefault();
        const distX = event.touches[0].pageX - event.touches[1].pageX;
        const distY = event.touches[0].pageY - event.touches[1].pageY;
        const currentDistance = Math.sqrt(distX * distX + distY * distY);
        const scaleChange = currentDistance / startX;
        scale *= scaleChange;
        scale = Math.max(0.1, scale); // Prevent scaling below 100%
        tween.vars.scale = scale;
        tween.invalidate().restart();
        // chart.css("transform", `scale(${scale})`);
        startX = currentDistance;
      }
    });
  });
});
